module.exports = __webpack_public_path__ + "static/media/business-time.749412b3.svg";